// Paired by index with en.ts.
export const es: readonly string[] = [
	"El armenio tiene su propio alfabeto. Mesrop Mashtots lo creó alrededor del año 405.",
	"Mashtots creó 36 letras. Más tarde, los armenios añadieron algunas más.",
	"Las letras armenias también eran números: Ա significaba 1 y Բ significaba 2.",
	"El duduk es un instrumento de viento tallado en madera de albaricoque.",
	"La UNESCO protege la música de duduk como un tesoro de la cultura mundial.",
	"El nombre científico del albaricoque, Prunus armeniaca, significa «ciruela armenia».",
	"La bandera de Armenia tiene tres franjas: roja, azul y albaricoque.",
	"El lavash es un pan armenio muy fino que se hornea en las paredes de un horno de barro.",
	"Ereván, la capital, es más antigua que Roma. Se fundó en el año 782 a. C.",
	"Desde Ereván se ve el monte Ararat, un símbolo de Armenia.",
	"El lago Seván está en lo alto de las montañas, a unos 1.900 metros sobre el mar.",
	"En las escuelas armenias, el ajedrez es una asignatura, como las matemáticas.",
	"Las Alas de Tatev son un teleférico de casi 6 kilómetros sobre un profundo desfiladero.",
	"Los armenios llaman a su país Հայաստան. ¡Pronto podrás leerlo!",
	"Los jachkares son cruces de piedra talladas como encaje. Hay miles por toda Armenia.",
	"El zapato de cuero más antiguo conocido, de unos 5.500 años, se encontró en una cueva armenia.",
	"En Vardavar, una fiesta de verano, la gente se echa agua unos a otros.",
	"El Matenadarán de Ereván guarda miles de libros antiguos escritos a mano.",
	"Armenia fue el primer país en hacer del cristianismo su religión oficial, en el año 301.",
	"Hola en armenio se dice Բարև. ¡Intenta leerla letra por letra!",
];
